import {Injectable} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ProductTranslation, Translations} from "./translations.model";
import {UmbrellaValidators} from "../../umbrella-common/validation/umbrella-validators";
import {TranslateService} from "@ngx-translate/core";
import {StandardName} from "../../store/state/order.state";
import {takeWhile} from "rxjs/operators";
import {StandaloneFormService} from "../../umbrella-common/services/standalone-form.service";

@Injectable()
export class TranslationsFormService extends StandaloneFormService {

	readonly notCopiableIso27001Fields = ['transferReason'];

	private isDraftTranslations: boolean;

	constructor(translate: TranslateService) {
		super(translate);
	}

	protected buildFormFor(formKey: string, [translations]: [Translations]) {
		this.isDraftTranslations = translations.isDraft;
		const form: FormGroup = new FormGroup({comment: new FormControl(translations.comment, UmbrellaValidators.textLengthBetween(3, 5000))});
		Object.keys(translations.productTranslations).forEach(standard => {
			translations.productTranslations[standard].forEach(productTranslation => {
				form.addControl(`${standard}-${productTranslation.subject}`, new FormControl(productTranslation.text, [Validators.required, UmbrellaValidators.textLengthBetween(1, 5000)]));
			});
		});

		this.copyValuesForIso277001(form);
		return form;
	}

	getControlNamesInOrder(): string[] {
		return [];
	}

	getTranslations(): Translations {
		let raw = this.getForm(StandaloneFormService.FORM_KEY).getRawValue();
		let translations: Translations = {
			productTranslations: {},
			comment: raw['comment'],
			isDraft: this.isDraftTranslations
		};

		Object.keys(raw).filter(key => key != 'comment').forEach(key => {
			let splittedKey = key.split('-');
			const standard = splittedKey[0];
			const translationSubject = splittedKey[1];
			const productTranslation = {subject: translationSubject, text: raw[key]} as ProductTranslation;

			if (translations.productTranslations.hasOwnProperty(standard)) {
				translations.productTranslations[standard].push(productTranslation);
			} else {
				translations.productTranslations[standard] = [productTranslation];
			}
		});

		return translations;
	}

	private copyValuesForIso277001(form: FormGroup) {
		Object.keys(form.controls)
			.filter(control => control.startsWith(StandardName.ISO_27001))
			.filter(control => !this.notCopiableIso27001Fields.some(fieldName => control.endsWith(fieldName)))
			.forEach(controlName => {
				form.controls[controlName].valueChanges.pipe(takeWhile(() => this.isFormInitialized())).subscribe(value => this.setValueForIso27701Equivalent(form, controlName, value));
			});
	}

	private getIso27701EquivalentControlName(controlName): string {
		const controlNameWithoutStandard: string = controlName.replace(StandardName.ISO_27001, '')
		return `${StandardName.ISO_27701}${controlNameWithoutStandard}`;
	}

	private setValueForIso27701Equivalent(form: FormGroup, controlName: string, value: any) {
		let iso27701ControlName = this.getIso27701EquivalentControlName(controlName);
		form.controls[iso27701ControlName]?.setValue(value);
	}
}
